import { IJobScheduleTypes, IScheduleState } from "models/IJobScheduleState";

const initialState: any = {
  dataTypes: [],
  curationTypes: [],
  jobSchedulesInfo: {},
  jobScheduleDetails: {},
};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case IJobScheduleTypes.FETCH_DATA_TYPES_SUCCESS:
      return {
        ...state,
        dataTypes: [...payload],
      };

    case IJobScheduleTypes.FETCH_CURATION_TYPES_SUCCESS:
      return {
        ...state,
        curationTypes: payload || [],
      };

    case IJobScheduleTypes.FETCH_JOB_SCHEDULE_LIST_SUCCESS:
      return {
        ...state,
        jobSchedulesInfo: {
          ...state.jobSchedulesInfo,
          data: [...payload.data],
        },
      };

    case IJobScheduleTypes.FETCH_JOB_SCHEDULE_SUCCESS:
      return {
        ...state,
        jobScheduleDetails: {
          ...payload,
        },
      };

    default:
      return state;
  }
};

export default reducer;
